var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cells.length)?_c('tr',_vm._l((_vm.cells),function(item,index){return _c('td',{key:index,attrs:{"colspan":item.colspan || 1}},[_c('table-cell-component',{attrs:{"bus":_vm.bus,"cell_item":item}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }